"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneLink = void 0;

var _DataBaseConnection = require("../controller/DataBaseConnection");

var _Message = require("../model/Message");

class PhoneLink {
  constructor(dbc) {
    this._dbc = dbc;
    this._db = dbc._db;
  }

  async link(number, restaurant, order) {
    await this._db.collection('phonelink').doc(number).set({
      restaurant,
      order
    });
  }

  async addMessage(number, message) {
    const {
      restaurant,
      order
    } = (await this._db.collection('phonelink').doc(number).get()).data();
    const rest = await this._dbc.getRestaurant(restaurant);
    const ml = await rest.getMessageList(order);
    await ml.addMessage(new _Message.Message({
      createdAt: new Date(),
      text: message,
      type: 'user',
      automated: false
    }));
  }

}

exports.PhoneLink = PhoneLink;